<form [formGroup]="roundRobinAssignmentForm" #formRef="ngForm">
    <div class="dialog-title">{{dialogBoxTitle}} Round Robin Assignment</div>
  
    <mat-form-field>
      <input type="text" placeholder="Sales Staff" matInput [matAutocomplete]="auto" formControlName="salesStaff" />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayStaffName">
        <mat-option  *ngFor="let staff of staffFilterList" [value]="staff">
          {{staff?.staffName}}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="roundRobinAssignmentForm.controls.salesStaff.errors?.required">Sales staff is required</mat-error>
      <mat-error *ngIf="!roundRobinAssignmentForm.controls.salesStaff.errors?.required &&
      roundRobinAssignmentForm.controls.salesStaff.errors?.forbiddenObject">Please select staff from dropdown.
      </mat-error>
    </mat-form-field>
  
    <mat-form-field class="with-hint">
      <input matInput placeholder="Weightage(%)" formControlName="weight" type="number" autocomplete="offAutoComplete"
        (input)="onWeightChange($event.target.value)" />
      <mat-hint>Balance Weightage: {{balanceWeight | percent: "1.0" }}</mat-hint>
      <mat-error *ngIf="roundRobinAssignmentForm.controls.weight.errors?.required">Weightage is required</mat-error>
      <mat-error *ngIf="roundRobinAssignmentForm.controls.weight.errors?.min">Weightage digit must not be lesser then 1
      </mat-error>
      <mat-error *ngIf="!roundRobinAssignmentForm.controls.weight.errors?.required &&
      roundRobinAssignmentForm.controls.weight.errors?.max">Weightage must be lesser then balance weightage
      </mat-error>
    </mat-form-field>
  
  
    <div class="dialog-buttons">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button mat-button cdkFocusInitial color="primary"
       (click)="submitAssignment(roundRobinAssignmentForm)">Save</button>
    </div>
  </form>